module.exports = __webpack_public_path__ + "images/facebook-icon---207896bfb56a47ffe458465f2914b5b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook-icon.png
// module id = 391
// module chunks = 0